module.exports = __webpack_public_path__ + "static/media/catalyst2021.a9ea2dfd.jpg";